import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SwFooterComponent } from './sw-footer/sw-footer.component';
import { SwHeaderComponent } from './sw-header/sw-header.component';
import { SwHomeComponent } from './sw-home/sw-home.component';
import { SwMainComponent } from './sw-main/sw-main.component';
import { SwMenuComponent } from './sw-menu/sw-menu.component';
import { SwPersonViewComponent } from './sw-person-view/sw-person-view.component';
import { FormsModule } from '@angular/forms';
import { SwLockSystemComponent } from './sw-lock-system/sw-lock-system.component';
import { HttpClientModule } from '@angular/common/http';
import { SwJwtService } from '../librarys/serves/sw-jwt.service';
import { SwException404Component } from './sw-exception/404.component';
import { SwException403Component } from './sw-exception/403.component';
import { SwSwitchUserComponent } from './sw-switch-user/sw-switch-user.component';
import { SwChangePasswordComponent } from './sw-change-password/sw-change-password.component';
import { DictionaryService } from '../librarys/serves/public/dictionary.service';
import { OninitService } from '../librarys/serves/oninit.service';
import { SwMenuService } from '../librarys/serves/sw-menu.service';
import { ProcessToDosService } from '../librarys/serves/public/process-to-dos.service';
import { BasicComponentsModule } from '../librarys/components/basic-components/basic-components.module';
import { SwLoadingmaskComponent } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.component';
import { AppComponentsModule } from '../librarys/components/app-components/app-components.module';
import { SwTreeMenuComponent } from './sw-tree-menu/sw-tree-menu.component';
import { SystemIdService } from '../librarys/serves/public/system-id.service';
import { SwNotificationComponent } from './sw-notification/sw-notification.component';
import { SwHeaderNoticeComponent } from './sw-header/sw-header-notice/sw-header-notice.component';
import { SwCompatibilityComponent } from './sw-exception/compatibility.component';
import { SwRecentlyEditComponent } from './sw-recently-edit/sw-recently-edit.component';
import { SwInstanceBoxComponent } from './sw-instance-box/sw-instance-box.component';
import { SwRelationBoxComponent } from './sw-relation-box/sw-relation-box.component';
import { SwMarkimgBoxComponent } from './sw-markimg-box/sw-markimg-box.component';
import { SwTripleSearchComponent } from './sw-triple-search/sw-triple-search.component';

import { ValidatorNumberTypeDirective } from "../areas/kms/validators/validator-number.directive";
import { ValidatorCodeDirective } from "../areas/kms/validators/validator-code.directive";
import { ValidatorMaxlengthDirective } from "../areas/kms/validators/validator-maxlength.directive";
import { ValidatorMinlengthDirective } from "../areas/kms/validators/validator-minlength.directive";
import { ValidatorLengthDirective } from "../areas/kms/kmsValidators/validator-length.directive";
import { ValidatorNumberDirective } from "../areas/kms/kmsValidators/validator-number.directive";
import { ValidatorCharTypeDirective } from "../areas/kms/kmsValidators/validator-char-type.directive";
import { TreeSelectFilterPipe } from "../areas/kms/pipes/tree-select-filter.pipe";
import { RolePipe } from "../areas/kms/pipes/role.pipe";
import { PosittionPipe } from "../areas/kms/pipes/position.pipe";

import { KmsConsoleComponent } from "../areas/kms/views/kms-console/kms-console.component";
import { MaterialConsoleComponent } from "../areas/kms/views/material-console/material-console.component";
import { MaterialCaptureComponent } from "../areas/kms/views/material-import/material-capture/material-capture.component";
import { MaterialQueryComponent } from "../areas/kms/views/material-manage/material-query/material-query.component";
import { MaterialSearchComponent } from "../areas/kms/views/material-search/material-search.component";
import { MaterialAddComponent } from "../areas/kms/views/material-manage/material-add/material-add.component";
import { MaterialViewComponent } from "../areas/kms/views/material-manage/material-view/material-view.component";
import { KnowledgeExtractComponent } from '../areas/kms/views/material-manage/knowledge-extract/knowledge-extract.component';
import { MaterialContentUpdateComponent } from "../areas/kms/views/material-manage/material-content-update/material-content-update.component";
import { ocrTextConfigBoxComponent } from "../areas/kms/views/material-manage/ocr-text-config-box/ocr-text-config-box.component";
import { OcrTextConfigCompareViewComponent } from "../areas/kms/views/material-manage/ocr-text-config-compare-view/ocr-text-config-compare-view.component";
import { ImgViewComponent } from '../areas/kms/components/img-view/img-view.component';
import { HistoryRecordsComponent } from "../areas/kms/views/material-manage/history-records/history-records.component";
import { CatalogueListComponent } from '../areas/kms/views/material-manage/material-catalogue/catalogue-list/catalogue-list.component';
import { CatalogueTreeComponent } from '../areas/kms/views/material-manage/material-catalogue/catalogue-tree/catalogue-tree.component';
import { CatalogueAddorupdateComponent } from '../areas/kms/views/material-manage/material-catalogue/catalogue-addorupdate/catalogue-addorupdate.component';
import { ImgListComponent } from '../areas/kms/views/material-manage/material-img/img-list/img-list.component';
import { ImgAddorupdateComponent } from '../areas/kms/views/material-manage/material-img/img-addorupdate/img-addorupdate.component';
import { TableListComponent } from '../areas/kms/views/material-manage/material-table/table-list/table-list.component';
import { TableAddorupdateComponent } from '../areas/kms/views/material-manage/material-table/table-addorupdate/table-addorupdate.component';
import { TextSearchComponent } from '../areas/kms/views/material-manage/text-search/text-search.component';
import { InstanceQueryComponent } from "../areas/kms/views/knowledge-instance/instance-query/instance-query.component";
import { InstanceAddComponent } from "../areas/kms/views/knowledge-instance/instance-add/instance-add.component";
import { KnowledgeVisualComponent } from "../areas/kms/views/knowledge-visual/knowledge-visual.component";
import { WebPageCaptureComponent } from "../areas/kms/views/material-import/web-page-capture/web-page-capture.component";
import { KnowledgeRecycleComponent } from "../areas/kms/views/knowledge-recycle/knowledge-recycle.component";
import { KnowledgeAttrmappingComponent } from "../areas/kms/views/knowledge-attrmapping/knowledge-attrmapping.component";
import { AligeditEditComponent } from "../areas/kms/views/knowledge-aligedit/aligedit-edit/aligedit-edit.component";
import { RelationQueryComponent } from "../areas/kms/views/knowledge-instance/relation-query/relation-query.component";
import { RelationCreateComponent } from '../areas/kms/views/knowledge-instance/relation-create/relation-create.component';
import { LabelQueryComponent } from "../areas/kms/views/label-manage/label-query/label-query.component";
import { LabelAddComponent } from "../areas/kms/views/label-manage/label-add/label-add.component";
import { RelationComponentComponent } from "../areas/kms/components/relation-component/relation-component.component";
import { LabelLibraryComponent } from "../areas/kms/components/label-library/label-library.component";
import { KmsFileUploaderComponent } from "../areas/kms/components/kms-file-uploader/kms-file-uploader.component";
import { KmsFileUploaderBoxComponent } from "../areas/kms/components/kms-file-uploader/kms-file-uploader-box/kms-file-uploader-box.component";
import { KmsTreeComponent } from "../areas/kms/components/kms-tree/kms-tree.component";
import { KmsTreeBoxComponent } from "../areas/kms/components/kms-tree/kms-tree-box/kms-tree-box.component";
import { KmsTreeMultiComponent } from "../areas/kms/components/kms-tree-multi/kms-tree-multi.component";
import { KmsTreeMultiBoxComponent } from "../areas/kms/components/kms-tree-multi/kms-tree-multi-box/kms-tree-multi-box.component";
import { ResourcesDetailComponent } from "../areas/kms/views/knowledge-resources/resources-detail/resources-detail.component";
import { GrabSourceQueryComponent } from "../areas/kms/views/grab-source-management/grab-source-query/grab-source-query.component";
import { GrabSourceAddComponent } from "../areas/kms/views/grab-source-management/grab-source-add/grab-source-add.component";
import { GrabSourceViewComponent } from "../areas/kms/views/grab-source-management/grab-source-view/grab-source-view.component";
import { ResourceListComponent } from "../areas/kms/components/resource-list/resource-list.component";
import { ResourcesSelectComponent } from "../areas/kms/views/knowledge-resources/resources-select/resources-select.component";
import { RelationViewComponent } from "../areas/kms/views/knowledge-instance/relation-view/relation-view.component";
import { KnowledgeBaseQueryComponent } from "../areas/kms/views/knowledge-base/knowledge-base-query/knowledge-base-query.component";
import { KnowledgeBaseAddComponent } from "../areas/kms/views/knowledge-base/knowledge-base-add/knowledge-base-add.component";
import { RelatedUserComponent } from "../areas/kms/views/knowledge-base/related-user/related-user.component";
import { ResourceMarkComponent } from "../areas/kms/views/knowledge-resources/resource-mark/resource-mark.component";
import { KnowledgeBaseViewComponent } from "../areas/kms/views/knowledge-base/knowledge-base-view/knowledge-base-view.component";
import { InstanceViewComponent } from "../areas/kms/views/knowledge-instance/instance-view/instance-view.component";
import { MarkQueryComponent } from "../areas/kms/components/mark-information/mark-query/mark-query.component";
import { MarkAddComponent } from "../areas/kms/components/mark-information/mark-add/mark-add.component";
import { LoadingComponentComponent } from "../areas/kms/views/loading-component/loading-component.component";
import { RelatedResourceQueryComponent } from "../areas/kms/components/mark-information/related-resource/related-resource-query/related-resource-query.component";
import { RelatedInstanceQueryComponent } from "../areas/kms/components/mark-information/related-instance/related-instance-query/related-instance-query.component";
import { DeleteConfirmComponent } from "../areas/kms/components/mark-information/delete-confirm/delete-confirm.component";
import { RelatedResourceSelectComponent } from "../areas/kms/components/mark-information/related-resource/related-resource-select/related-resource-select.component";
import { RelatedInstanceSelectComponent } from "../areas/kms/components/mark-information/related-instance/related-instance-select/related-instance-select.component";
import { ImgMarkQueryComponent } from "../areas/kms/views/knowledge-resources/img-mark-query/img-mark-query.component";
import { InstanceInfoViewComponent } from "../areas/kms/components/instance-info-view/instance-info-view.component";
import { KmgMapComponent } from "../areas/kms/components/kmg-map/kmg-map.component";
import { EditDatasourceComponent } from '../areas/kms/components/edit-datasource/edit-datasource.component';
import { InstanceSelectComponent } from "../areas/kms/components/instance-select/instance-select.component";
import { MarkViewComponent } from "../areas/kms/components/mark-information/mark-view/mark-view.component";
import { LabelSelectComponent } from "../areas/kms/components/label-select/label-select.component";
import { RulesQueryComponent } from "../areas/kms/views/system-rules/rules-query/rules-query.component";
import { RulesAddComponent } from "../areas/kms/views/system-rules/rules-add/rules-add.component";
import { InstanceRecordInfoViewComponent } from "../areas/kms/components/instance-record-info-view/instance-record-info-view.component";
import { DictionaryQueryComponent } from "../areas/kms/views/dictionary-management/dictionary-query/dictionary-query.component";
import { DictionaryAddComponent } from "../areas/kms/views/dictionary-management/dictionary-add/dictionary-add.component";
import { DictionaryViewComponent } from "../areas/kms/views/dictionary-management/dictionary-view/dictionary-view.component";
import { TabInfoQueryComponent } from "../areas/kms/components/tab-information/tab-info-query/tab-info-query.component";
import { TabInfoAddComponent } from "../areas/kms/components/tab-information/tab-info-add/tab-info-add.component";
import { TabInfoViewComponent } from "../areas/kms/components/tab-information/tab-info-view/tab-info-view.component";
import { InstanceSelectMultiComponent } from "../areas/kms/components/instance-select-multi/instance-select-multi.component";
import { ModelVisualComponent } from '../areas/kms/views/model-visual/model-visual/model-visual.component';
import { ModelAddComponent } from "../areas/kms/views/model-visual/model-add/model-add.component";
import { ModelEditComponent } from '../areas/kms/views/model-visual/model-edit/model-edit.component';
import { VersionEditComponent } from '../areas/kms/views/model-visual/version-edit/version-edit.component';
import { ModelShowComponent } from '../areas/kms/views/model-visual/model-show/model-show.component';
import { ConceptAddorupdateComponent } from '../areas/kms/views/model-visual/concept-manage/concept-addorupdate/concept-addorupdate.component';
import { ConceptViewComponent } from '../areas/kms/views/model-visual/concept-manage/concept-view/concept-view.component';
import { ConceptCopyComponent } from '../areas/kms/views/model-visual/concept-manage/concept-copy/concept-copy.component';
import { ConceptSortComponent } from '../areas/kms/views/model-visual/concept-manage/concept-sort/concept-sort.component';
import { AttrAddorupdateComponent } from '../areas/kms/views/model-visual/attr-manage/attr-addorupdate/attr-addorupdate.component';
import { FieldAddorupdateComponent } from '../areas/kms/views/model-visual/attr-manage/field-addorupdate/field-addorupdate.component';
import { AttrViewComponent } from '../areas/kms/views/model-visual/attr-manage/attr-view/attr-view.component';
import { AttrSortComponent } from '../areas/kms/views/model-visual/attr-manage/attr-sort/attr-sort.component';
import { FieldsViewComponent } from '../areas/kms/views/model-visual/attr-manage/field-view/field-view.component';
import { RelQueryComponent } from '../areas/kms/views/model-visual/rel-manage/rel-query/rel-query.component';
import { RelAddorupdateComponent } from '../areas/kms/views/model-visual/rel-manage/rel-addorupdate/rel-addorupdate.component';
import { RelViewComponent } from '../areas/kms/views/model-visual/rel-manage/rel-view/rel-view.component';
import { RelSortComponent } from '../areas/kms/views/model-visual/rel-manage/rel-sort/rel-sort.component';
import { InstanceVerifyComponent } from '../areas/kms/views/knowledge-instance/instance-verify/instance-verify.component';
import { QuickAddRelationComponent } from '../areas/kms/components/quick-add-relation/quick-add-relation.component';
import { RecentlyEditListComponent } from '../areas/kms/components/recently-edit-list/recently-edit-list.component';
import { AddResourceListComponent } from '../areas/kms/components/add-resource-list/add-resource-list.component';
import { QuickTripleSearchComponent } from '../areas/kms/components/quick-triple-search/quick-triple-search.component';
import { ResourceVerifyComponent } from '../areas/kms/views/knowledge-resources/resource-verify/resource-verify.component';
import { SelectImgsComponent } from '../areas/kms/views/material-manage/material-catalogue/select-imgs/select-imgs.component';
import { MachineLearningQueryComponent } from '../areas/kms/views/machine-learning/machine-learning-query/machine-learning-query.component';
import { SetAttrsComponent } from '../areas/kms/views/machine-learning/set-attrs/set-attrs.component';
import { GetInstanceComponent } from '../areas/kms/views/machine-learning/get-instance/get-instance.component';
import { TaskStatisticComponent } from '../areas/kms/views/task-statistic/task-statistic.component';
import { SwAddResourceComponent } from './sw-add-resource/sw-add-resource.component';
import { KnowledgeExtractManagementComponent } from '../areas/kms/views/knowledge-extract-management/knowledge-extract-management.component';
import { ExtractTaskConfigComponent } from '../librarys/components/app-components/extract-task-config/extract-task-config.component';
import { GraphViewComponent1 } from '../areas/kms/views/entity-relation-mark/graph-view/graph-view.component';
import { NewEntityRelationMarkComponent } from '../areas/kms/views/entity-relation-mark/new-entity-relation-mark/new-entity-relation-mark.component';
import { TextMarkListComponent } from '../areas/kms/views/entity-relation-mark/text-mark-list/text-mark-list.component';
import { TextMarkMenuComponent } from '../areas/kms/views/entity-relation-mark/text-mark-menu/text-mark-menu.component';
import { AdvancedSearchComponent } from '../areas/kms/./views/advanced-search/advanced-search.component';
import { CenterNodeQueryComponent } from '../areas/kms/./views/knowledge-application/center-node-query/center-node-query.component';
import { PathQueryComponent } from '../areas/kms/views/knowledge-application/path-query/path-query.component';
import { OntologyStructureQueryComponent } from '../areas/kms/views/knowledge-application/ontology-structure-query/ontology-structure-query.component';
import { ViewSourceMaterialComponent } from '../areas/kms/views/knowledge-extract-management/view-source-material/view-source-material.component';
import { CatalogueAddorupComponent } from '../areas/kms/views/material-manage/catalogue-addorup/catalogue-addorup.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    BasicComponentsModule,
    AppComponentsModule,
    FormsModule
  ],
  exports:[
    SwFooterComponent,
    SwHeaderComponent,
    SwTreeMenuComponent,
    SwMainComponent,
    SwHomeComponent,
    SwMenuComponent,
    SwLoadingmaskComponent,
    SwException404Component,
    
    SwInstanceBoxComponent,
    SwRelationBoxComponent,
    SwMarkimgBoxComponent,
    SwRecentlyEditComponent,
    SwTripleSearchComponent,

    ValidatorNumberTypeDirective,
    ValidatorMaxlengthDirective,
    ValidatorMinlengthDirective,
    ValidatorCodeDirective,
    ValidatorLengthDirective,
    ValidatorNumberDirective,
    ValidatorCharTypeDirective,
    TreeSelectFilterPipe,
    RolePipe,
    PosittionPipe,

    KmsConsoleComponent,
    MaterialConsoleComponent,
    MaterialCaptureComponent,
    MaterialQueryComponent,
    MaterialAddComponent,
    MaterialViewComponent,
    KnowledgeExtractComponent,
    MaterialContentUpdateComponent,
    ocrTextConfigBoxComponent,
    OcrTextConfigCompareViewComponent,
    ImgViewComponent,
    HistoryRecordsComponent,
    CatalogueListComponent,
    CatalogueTreeComponent,
    CatalogueAddorupdateComponent,
    ImgListComponent,
    ImgAddorupdateComponent,
    TableListComponent,
    TableAddorupdateComponent,
    TextSearchComponent,
    MaterialSearchComponent,
    InstanceQueryComponent,
    InstanceAddComponent,
    KnowledgeVisualComponent,
    WebPageCaptureComponent,
    KnowledgeRecycleComponent,
    KnowledgeAttrmappingComponent,
    AligeditEditComponent,
    RelationQueryComponent,
    RelationCreateComponent,
    LabelQueryComponent,
    LabelAddComponent,
    LabelLibraryComponent,
    ResourcesDetailComponent,
    KmsFileUploaderComponent,
    KmsFileUploaderBoxComponent,
    KmsTreeComponent,
    KmsTreeBoxComponent,
    KmsTreeMultiComponent,
    KmsTreeMultiBoxComponent,
    GrabSourceQueryComponent,
    GrabSourceAddComponent,
    GrabSourceViewComponent,
    ResourceListComponent,
    ResourcesSelectComponent,
    RelationViewComponent,
    KnowledgeBaseQueryComponent,
    KnowledgeBaseAddComponent,
    RelatedUserComponent,
    ResourceMarkComponent,
    KnowledgeBaseViewComponent,
    InstanceViewComponent,
    RelationComponentComponent,
    MarkQueryComponent,
    MarkAddComponent,
    LoadingComponentComponent,
    RelatedResourceQueryComponent,
    RelatedInstanceQueryComponent,
    DeleteConfirmComponent,
    RelatedResourceSelectComponent,
    RelatedInstanceSelectComponent,
    ImgMarkQueryComponent,
    InstanceInfoViewComponent,
    KmgMapComponent,
    EditDatasourceComponent,
    InstanceSelectComponent,
    MarkViewComponent,
    LabelSelectComponent,
    InstanceRecordInfoViewComponent,
    RulesQueryComponent,
    RulesAddComponent,
    DictionaryQueryComponent,
    DictionaryAddComponent,
    DictionaryViewComponent,
    TabInfoQueryComponent,
    TabInfoAddComponent,
    TabInfoViewComponent,
    InstanceSelectMultiComponent,
    ModelVisualComponent,
    ModelShowComponent,
    ModelAddComponent,
    ModelEditComponent,
    VersionEditComponent,
    ConceptAddorupdateComponent,
    ConceptViewComponent,
    ConceptCopyComponent,
    ConceptSortComponent,
    AttrAddorupdateComponent,
    FieldAddorupdateComponent,
    AttrViewComponent,
    AttrSortComponent,
    FieldsViewComponent,
    RelQueryComponent,
    RelAddorupdateComponent,
    RelViewComponent,
    RelSortComponent,
    InstanceVerifyComponent,
    QuickAddRelationComponent,
    RecentlyEditListComponent,
    AddResourceListComponent,
    QuickTripleSearchComponent,
    ResourceVerifyComponent,
    SelectImgsComponent,
    MachineLearningQueryComponent,
    SetAttrsComponent,
    GetInstanceComponent,
    TaskStatisticComponent,
    ExtractTaskConfigComponent,
    KnowledgeExtractManagementComponent,
    GraphViewComponent1,
    NewEntityRelationMarkComponent,
    TextMarkListComponent,
    TextMarkMenuComponent,
    AdvancedSearchComponent, CenterNodeQueryComponent, PathQueryComponent,OntologyStructureQueryComponent, ViewSourceMaterialComponent,
    CatalogueAddorupComponent
  ],
  providers:[SwJwtService,DictionaryService,SwMenuService,OninitService,ProcessToDosService,
    ValidatorLengthDirective,
    ValidatorNumberDirective,
    ValidatorCharTypeDirective
  ],
  entryComponents: [SwLoadingmaskComponent,SwPersonViewComponent,SwLockSystemComponent,SwSwitchUserComponent,SwChangePasswordComponent,SwHeaderNoticeComponent,
    MaterialAddComponent,
    MaterialViewComponent,
    MaterialContentUpdateComponent,
    ocrTextConfigBoxComponent,
    OcrTextConfigCompareViewComponent,
    ImgViewComponent,
    HistoryRecordsComponent,
    CatalogueAddorupdateComponent,
    ImgAddorupdateComponent,
    TableAddorupdateComponent,
    KmsFileUploaderComponent,
    KmsFileUploaderBoxComponent,
    KmsTreeComponent,
    KmsTreeBoxComponent,
    KmsTreeMultiComponent,
    KmsTreeMultiBoxComponent,
    ResourcesDetailComponent,
    LabelLibraryComponent,
    GrabSourceAddComponent,
    GrabSourceViewComponent,
    ResourcesSelectComponent,
    ModelAddComponent,
    ModelEditComponent,
    VersionEditComponent,
    RelationCreateComponent,
    RelationViewComponent,
    LabelAddComponent,
    KnowledgeBaseAddComponent,
    RelatedUserComponent,
    KnowledgeBaseViewComponent,
    RelationComponentComponent,
    DeleteConfirmComponent,
    RelatedResourceSelectComponent,
    RelatedInstanceSelectComponent,
    InstanceInfoViewComponent,
    KmgMapComponent,
    EditDatasourceComponent,
    RulesAddComponent,
    DictionaryAddComponent,
    DictionaryViewComponent,
    TabInfoAddComponent,
    TabInfoViewComponent,
    InstanceVerifyComponent,
    QuickAddRelationComponent,
    RecentlyEditListComponent,
    AddResourceListComponent,
    QuickTripleSearchComponent,
    ResourceVerifyComponent,
    SelectImgsComponent,
    SetAttrsComponent,
    GetInstanceComponent,
    ExtractTaskConfigComponent,
    KnowledgeExtractManagementComponent,
    GraphViewComponent1,
    NewEntityRelationMarkComponent,
    TextMarkListComponent,
    TextMarkMenuComponent,
    AdvancedSearchComponent, CenterNodeQueryComponent, PathQueryComponent,OntologyStructureQueryComponent, ViewSourceMaterialComponent,
    CatalogueAddorupComponent
  ],
  declarations: [
    SwLoadingmaskComponent,
    SwFooterComponent,
    SwHeaderComponent,
    SwHomeComponent,
    SwMainComponent,
    SwMenuComponent,
    SwTreeMenuComponent,
    SwPersonViewComponent,
    SwLockSystemComponent,
    SwException404Component,
    SwException403Component,
    SwCompatibilityComponent,
    SwSwitchUserComponent,
    SwChangePasswordComponent,
    SwNotificationComponent,
    SwHeaderNoticeComponent,
    SwRecentlyEditComponent,
    SwInstanceBoxComponent,
    SwRelationBoxComponent,
    SwMarkimgBoxComponent,
    SwTripleSearchComponent,

    ValidatorNumberTypeDirective,
    ValidatorMaxlengthDirective,
    ValidatorMinlengthDirective,
    ValidatorCodeDirective,
    ValidatorLengthDirective,
    ValidatorNumberDirective,
    ValidatorCharTypeDirective,
    TreeSelectFilterPipe,
    RolePipe,
    PosittionPipe,

    KmsConsoleComponent,
    MaterialConsoleComponent,
    MaterialCaptureComponent,
    MaterialQueryComponent,
    MaterialAddComponent,
    MaterialViewComponent,
    KnowledgeExtractComponent,
    MaterialContentUpdateComponent,
    ocrTextConfigBoxComponent,
    OcrTextConfigCompareViewComponent,
    ImgViewComponent,
    HistoryRecordsComponent,
    CatalogueListComponent,
    CatalogueTreeComponent,
    CatalogueAddorupdateComponent,
    ImgListComponent,
    ImgAddorupdateComponent,
    TableListComponent,
    TableAddorupdateComponent,
    TextSearchComponent,
    MaterialSearchComponent,
    InstanceQueryComponent,
    InstanceAddComponent,
    KnowledgeVisualComponent,
    ModelAddComponent,
    ModelEditComponent,
    VersionEditComponent,
    WebPageCaptureComponent,
    KnowledgeRecycleComponent,
    KnowledgeAttrmappingComponent,
    AligeditEditComponent,
    RelationQueryComponent,
    RelationCreateComponent,
    LabelQueryComponent,
    LabelAddComponent,
    LabelLibraryComponent,
    ResourcesDetailComponent,
    KmsFileUploaderComponent,
    KmsFileUploaderBoxComponent,
    KmsTreeComponent,
    KmsTreeBoxComponent,
    KmsTreeMultiComponent,
    KmsTreeMultiBoxComponent,
    GrabSourceQueryComponent,
    GrabSourceAddComponent,
    GrabSourceViewComponent,
    ResourceListComponent,
    ResourcesSelectComponent,
    RelationViewComponent,
    KnowledgeBaseQueryComponent,
    KnowledgeBaseAddComponent,
    RelatedUserComponent,
    ResourceMarkComponent,
    KnowledgeBaseViewComponent,
    InstanceViewComponent,
    RelationComponentComponent,
    MarkQueryComponent,
    MarkAddComponent,
    LoadingComponentComponent,
    RelatedResourceQueryComponent,
    RelatedInstanceQueryComponent,
    DeleteConfirmComponent,
    RelatedResourceSelectComponent,
    RelatedInstanceSelectComponent,
    ImgMarkQueryComponent,
    InstanceInfoViewComponent,
    KmgMapComponent,
    EditDatasourceComponent,
    InstanceSelectComponent,
    MarkViewComponent,
    LabelSelectComponent,
    InstanceRecordInfoViewComponent,
    RulesQueryComponent,
    RulesAddComponent,
    DictionaryQueryComponent,
    DictionaryAddComponent,
    DictionaryViewComponent,
    TabInfoQueryComponent,
    TabInfoAddComponent,
    TabInfoViewComponent,
    InstanceSelectMultiComponent,
    ModelVisualComponent,
    ModelShowComponent,
    ConceptAddorupdateComponent,
    ConceptViewComponent,
    ConceptCopyComponent,
    ConceptSortComponent,
    AttrAddorupdateComponent,
    FieldAddorupdateComponent,
    AttrViewComponent,
    AttrSortComponent,
    FieldsViewComponent,
    RelQueryComponent,
    RelAddorupdateComponent,
    RelViewComponent,
    RelSortComponent,
    InstanceVerifyComponent,
    QuickAddRelationComponent,
    RecentlyEditListComponent,
    AddResourceListComponent,
    QuickTripleSearchComponent,
    ResourceVerifyComponent,
    SelectImgsComponent,
    MachineLearningQueryComponent,
    SetAttrsComponent,
    GetInstanceComponent,
    TaskStatisticComponent,
    SwAddResourceComponent,
    ExtractTaskConfigComponent,
    KnowledgeExtractManagementComponent,
    GraphViewComponent1,
    NewEntityRelationMarkComponent,
    TextMarkListComponent,
    TextMarkMenuComponent,
    AdvancedSearchComponent, CenterNodeQueryComponent, PathQueryComponent,OntologyStructureQueryComponent, ViewSourceMaterialComponent,
    CatalogueAddorupComponent
  ]
})
export class HomeModule { }

